import { render, staticRenderFns } from "./InstrumentCurrencyCell.vue?vue&type=template&id=520eb286&scoped=true&"
import script from "./InstrumentCurrencyCell.vue?vue&type=script&lang=js&"
export * from "./InstrumentCurrencyCell.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentCurrencyCell.vue?vue&type=style&index=0&id=520eb286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520eb286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
